import { Injectable, Injector } from '@angular/core';
import { Params } from '@angular/router';
import { FACTORY_RESOURCE_TYPE, FACTORY_RESOURCE_PROVIDER } from 'app/services/globals';
import { Observable } from 'rxjs';
import { IPrimaryResourceUrlInformationService } from './interfaces/IPrimaryResourceUrlInformationService';
import { UrlInformationBaseService } from './url-information-base.service';

@Injectable({
    providedIn: 'root'
})
export class FactoryUrlInformationService extends UrlInformationBaseService implements IPrimaryResourceUrlInformationService {

    public get dataFactoryId(): string { // todo, try to remove this and use getResourceId instead
        return this.resourceId;
    }
    // used only in integration tests
    public set dataFactoryId(value: string) {
        this.resourceId = value;
    }
    public get dataFactoryName(): string {
        return this.resourceName;
    }
    // used only in integration tests
    public set dataFactoryName(value: string) {
        this.resourceName = value;
    }
    public get dataFactoryTags(): { [propertyName: string]: string } {
        return this.resourceTags;
    }
    public get isFactoryProvided(): boolean {
        return this.isResourceProvided;
    }
    // used only in integration tests
    public set isFactoryProvided(value: boolean) {
        this.isResourceProvided = value;
    }

    public resourceProviderName = FACTORY_RESOURCE_PROVIDER;
    public resourceType = FACTORY_RESOURCE_TYPE;
    public resourceTypeNamesInSearch: string[] = ['Factory', 'factory'];

    public openSummaryPageWithSsisIrName: string;
    public irSource: string;

    public get dataFactoryLocation$(): Observable<string> {
        return this.resourceLocation$;
    }

    public get dataFactoryLocation(): string {
        return this.resourceLocation;
    }

    constructor(_injector: Injector) {
        super(_injector);
    }

    public setFactoryLocation(location: string): void {
        this.setResourceLocation(location);
    }

    public setFactoryInfo(queryParams: Params): void {
        this.setResourceInfo(queryParams);

        if (queryParams['openSummaryPageWithSsisIrName']) {
            this.openSummaryPageWithSsisIrName = queryParams['openSummaryPageWithSsisIrName'];
        }

        if (queryParams['irSource'] || queryParams['source']) {
            this.irSource = queryParams['irSource'] || queryParams['source'];
        }
    }

    public isFactoryChanged(queryParams: Params): boolean {
        const factoryIdOptions = this.resourceTypeNamesInSearch.map((item) => queryParams[item]).filter((item) => !!item);
        if (factoryIdOptions[0]) {
            return !!this.resourceId && this.resourceId.toLowerCase() !== decodeURIComponent(factoryIdOptions[0]).toLowerCase();
        }

        return true;
    }
}
